import axios from "axios";
import { ElMessage } from "element-plus";

const instance = axios.create(
  {
    baseURL: import.meta.env
      .PROD
      ? import.meta.env
          .VITE_API_URL_PROD
      : import.meta.env
          .VITE_API_URL_DEV,
    timeout: 5000,
    headers: {
      "Content-Type":
        "application/json",
    },
  }
);

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token =
      sessionStorage.getItem(
        "token"
      );
    // 获取当前语言环境
    const locale =
      localStorage.getItem(
        "locale"
      ) || "zh-cn";
    config.headers = {
      ...config.headers,
      locale,
      "Accept-Language":
        locale,
      ...(token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {}),
    };

    return config;
  },
  (error) => {
    ElMessage.error(
      "请求发送失败"
    );
    return Promise.reject(
      error
    );
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const {
      code,
      msg,
      data,
    } = response.data;
    // 针对注册接口的特殊处理

    if (code === 0) {
      // 修改这里，使用后端约定的成功状态码 0
      return data;
    }
    if (code === 500) {
      ElMessage.error(
        msg || "操作失败"
      );
      return Promise.reject(
        new Error(msg)
      );
    }

    ElMessage.error(
      msg || "请求失败"
    );
    return Promise.reject(
      new Error(msg)
    );
  },
  (error) => {
    const status =
      error.response?.status;

    switch (status) {
      case 211:
        ElMessage.error(
          "登录已过期，请重新登录"
        );
        localStorage.clear();
        window.location.reload();
        break;
      case 210:
        ElMessage.error(
          "没有访问权限"
        );
        break;
      case 202:
        ElMessage.error(
          "参数不正确"
        );
        break;
      default:
        ElMessage.error(
          "网络错误，请稍后重试"
        );
    }
    return Promise.reject(
      error
    );
  }
);

// 封装请求方法
export const http = {
  get: (url, params) =>
    instance.get(url, {
      params,
    }),
  post: (url, data) =>
    instance.post(url, data),
  put: (url, data) =>
    instance.put(url, data),
  delete: (url) =>
    instance.delete(url),
};

export default instance;
